import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useFeedback } from '../../contexts/FeedbackContext';
import FeedbackPanel from './FeedbackPanel';

/**
 * The one mounted instance of the feedback panel, wired to auth (for the name
 * in the thank-you) and to the open flag the rail, the top bar and the
 * `/feedback` deep link all share.
 *
 * Mounted app-wide so the panel floats over whatever page the person is on —
 * including the wizard, which has its own chrome and no top bar of its own.
 * Idle until someone opens it: signed out, it renders nothing.
 */

/** Greeting name — first name only; a full name in a thank-you reads like mail. */
const firstNameOf = (fullName?: string | null, displayName?: string | null): string | undefined => {
  const full = (fullName || displayName || '').trim();
  return full ? full.split(/\s+/)[0] : undefined;
};

export const ConnectedFeedbackPanel: React.FC = () => {
  const { currentUser, backendUser } = useAuth();
  const { open, closeFeedback } = useFeedback();

  if (!currentUser) return null;

  return (
    <FeedbackPanel
      open={open}
      onClose={closeFeedback}
      personName={firstNameOf(backendUser?.fullName, currentUser.displayName)}
    />
  );
};

export default ConnectedFeedbackPanel;
